import { render } from "./EditHormoneDialog.vue?vue&type=template&id=3d32a64e&scoped=true"
import script from "./EditHormoneDialog.vue?vue&type=script&lang=js"
export * from "./EditHormoneDialog.vue?vue&type=script&lang=js"

import "./EditHormoneDialog.vue?vue&type=style&index=0&id=3d32a64e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d32a64e"]])

export default __exports__